// client/src/pages/RecipeShared.js
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import RecipeCard from "../components/RecipeCard";

export default function RecipeShared() {
  const { id } = useParams();
  const [recipe, setRecipe] = useState(null);
  const baseURL = process.env.REACT_APP_BE;

  useEffect(() => {
    axios
      .get(`${baseURL}/recipes/recipe/${id}`)
      .then((res) => {
        setRecipe(res.data);
      })
      .catch((err) => {
        setRecipe(null);
      });
  }, [id]);

  return (
    <div className="max-w-2xl mx-auto px-4 mt-10">
      {recipe ? (
        <RecipeCard recipe={recipe} />
      ) : (
        <p className="text-gray-500">Recipe not found or has been removed.</p>
      )}
    </div>
  );
}
